import { MAIN_CONTROLLER } from "@/utils/main_controller.js";
import { PREPOPULATE_INPUT } from "@/utils/prepopulate_input.js";
import { ENTERPRISE_CREDIT_CHECK, ENTERPRISE_TRANSUNION_KYB_ENQUIRY_REASON} from "@/utils/constants.js";
import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import { format_business_registration_number } from "@/utils/validations.js";
import BreadCrumb from "@/components/BreadCrumb/BreadCrumb.vue";
import ClientLogo from "@/components/ClientLogo/ClientLogo.vue";

export default {
  name: 'EnterpriseTransUnionCreditVerification',
  mixins: [MAIN_CONTROLLER, PREPOPULATE_INPUT],
  components: {
    BreadCrumb,
    ClientLogo
  },
  data: () => ({
    registration_number: '',
    json_data: {},
    error_messages: {
      registration_number: '',
    },
    isFieldDisabled: false,
  }),

  computed: {
    workflow_id() {
      return this.$store.getters.get_workflow_id;
    }
  },
  methods: {
    validate_registration_number(event) {
      const { formatted_input, new_cursor_position } = format_business_registration_number(event);

      // Update the registration number model
      this.registration_number = formatted_input;

      // Adjust the cursor position
      this.$nextTick(() => {
        event.target.selectionStart = new_cursor_position;
        event.target.selectionEnd = new_cursor_position;
      });
    },

    validate_all_fields() {
      let valid = true;
      let message = 'This field is required';

      const fields = ['registration_number'];

      fields.forEach((field) => {
        if (!this[field]) {
          this.error_messages[field] = message;
          valid = false;
        } else {
          this.error_messages[field] = '';
        }
      });

      return valid;
    },

    async get_customer_data() {
      const TOKEN = localStorage.getItem('token');
      const CUSTOMER_DATA_URL = `${API_BASE_URL}/verify_api/system_management_api/get_customer_data/`;

      try {
        const response = await $.ajax({
          url: CUSTOMER_DATA_URL,
          method: 'GET',
          contentType: 'application/json',
          headers: {
            Authorization: `Token ${TOKEN}`,
          },
          beforeSend: () => {
            Swal.fire({
              text: 'Loading ...',
              allowEscapeKey: false,
              allowOutsideClick: false,
              didOpen: () => Swal.showLoading(),
            });
          }
        });

        Swal.close();

        // Populate fields and set disabled state based on whether data exists
        var company_registration = response.company_registration || '';
        if (company_registration && company_registration.length >= 12) {
          var event = {
            target: {
              value: company_registration,
              selectionStart: company_registration.length
            },
            key: ''
          };
          this.validate_registration_number(event)

          // Only disable fields that have prepopulated data
          this.isFieldDisabled = {
            registration_number: !!response.company_registration,
          };
        }
        

      } catch (error) {
        Swal.close();
        console.error('Error fetching customer data:', error);
      }
    },

    enterprise_transunion_credit_check() {
      if (!this.validate_all_fields()) {
            return;
      }
      const TOKEN = localStorage.getItem('token');
      const ENTERPRISE_TRANSUINON_CREDIT_CHECK_API = `${API_BASE_URL}/verify_api/company_verification/enterprise_kyb/`;

      this.error = '';

      // Remove slashes from the registration number
      const sanitized_registration_number = this.registration_number.replace(/\//g, '');

      $.ajax({
        url: ENTERPRISE_TRANSUINON_CREDIT_CHECK_API,
        method: 'POST',
        contentType: 'application/json',
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        data: JSON.stringify({
          registration_number: sanitized_registration_number,
          enquiry_reason: ENTERPRISE_TRANSUNION_KYB_ENQUIRY_REASON,
          workflow_id: this.workflow_id,
          service_name: ENTERPRISE_CREDIT_CHECK,
          on_behalf_application: this.$route.name === 'behalf_application' ? true : false,
        }),
        beforeSend: () => {
          Swal.fire({
            text: 'Loading ...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
          });
        },
        success: () => {
          Swal.close();
          this.completeService();
        },
        error: (error) => {
          Swal.close();
          let error_message = 'Something went wrong!';

          if (error.responseJSON) {
            error_message = error.responseJSON;
            $('.error-message').text(error_message).removeClass('d-none');
            setTimeout(() => {
              $('.error-message').text('').addClass('d-none');
            }, 3000);
          } else {
            $('.error-message').text(error_message).removeClass('d-none');
            setTimeout(() => {
              $('.error-message').text('').addClass('d-none');
            }, 3000);
          }
        }
      });
    },
  },

  mounted() {
    if (!validateToken(this.$router)) {
      return;
    }
    this.get_customer_data();
  }
};
